



























import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";

@Component({
    name: "CardStatistic"
})
export default class extends mixins(CommonMixin) {
    @Prop() data!: any;
    @Prop() icon!: any;
    @Prop({ type: Boolean, default: false }) isCount!: boolean;
}
